import axios from "axios";
import { Message, MessageBox } from 'element-ui'
import router from "@/router";
// 创建axios实例
var instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 1000 * 60,
    crossDomain: true,
    withCredentials: true,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    }
});

instance.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => Promise.error(error)
);

function userLogin(url) {
    var className = quick.os.android ? 'cn.medlive.android.account.activity.AccountLoginActivity' : 'LogInViewController';
    quick.page.openLocal({
        className: className,
        // 为1则是打开已存在的页面，会杀掉所有该页面上的页面
        isOpenExist: 0,
        // 额外数据，注意额外数据只能一层键值对形式，不能再包裹子json
        data: {
            // key: 'value1',
            // userid: '2417022'
        },
        success: function (result) {
            var loginResult = JSON.stringify(result);
            loginResult = JSON.parse(loginResult);
            var khd = quick.os.android ? 'android' : 'ios';
            if (khd == 'android') {
                quick.page.close('value2');
            }
            quick.page.open(url + '?token=' + loginResult.resultData);
        },
        error: function (error) {
            console.log('失败:' + JSON.stringify(error));
        }
    });
};

let count = 0;
// 响应拦截器
instance.interceptors.response.use(
    // 请求成功
    (res) => {
        if (res.status === 200) {
            if (res.data.code === 0) { // 网络请求成功
                return Promise.resolve(res.data);
            } else if (res.data.code == 700) {
                count=count+1;
                if(count==1){
                    MessageBox.confirm(res.data.msg, {
                        confirmButtonText: "确定",
                        showCancelButton: false,
                        closeOnClickModal: false,
                        showClose: false,
                        center: true,
                    }).then(() => {
                        //如果确认
                        count = 0;
                        if (process.env.VUE_APP_MODE !== 'production') {
                            window.location.href = `https://medgpt-test.medlive.cn/api/cas/logout?token=${window.localStorage.getItem('token')}`
                        } else {
                            window.location.href = `${window.location.origin}/api/cas/logout?token=${window.localStorage.getItem('token')}`
                        }
                    })
                }
                
            } else if(res.data.error == 400 ){ // token 过期
                window.location.href = `${window.location.href}/auth`
                return
            } else if (res.data.code == 401) {
              console.log(res, "----------");
              MessageBox.confirm(res.data.msg, {
                confirmButtonText: "去购买",
                showCancelButton: true,
                closeOnClickModal: false,
                showClose: false,
                center: true,
              })
                .then(() => {
                  //如果确认
                  router.push({
                    name: "buyvip",
                  });
                })
                .catch(() => {
                  Message({
                    type: "info",
                    message: "已取消",
                    center: true,
                  });
                });
              return Promise.reject(res);
            } else if (res.data.code == 701) {
              console.log(res, "----------");
              MessageBox.confirm(res.data.msg, {
                showConfirmButton: false,
                showCancelButton: false,
                closeOnClickModal: false,
                showClose: true,
                center: true,
              });
              return Promise.reject(res);
            } else if (res.data.code == 703) {
              console.log(res, "----------");
              MessageBox.confirm(res.data.msg, {
                showConfirmButton: false,
                showCancelButton: false,
                closeOnClickModal: false,
                showClose: false,
                center: true,
              });
              return Promise.reject(res);
            } else if (res.data.code == 705) {
              console.log("11111111111111111111");
              if (process.env.VUE_APP_MODE !== "production") {
                userLogin("https://medgpt-test.medlive.cn/web/");
              } else {
                userLogin("https://gpt.medlive.cn/web/");
              }
            } else {
              Message.error(res.data.msg);
              return Promise.reject(res);
            }
        } else {
            Message.error('请求失败');
            Promise.reject(res.data);
        }
    },
    // 请求失败
    (error) => {
        // 请求已发出，但是不在2xx的范围
        Message.error('服务器请求失败');
        return Promise.reject(error);
    }
);

export default instance;